import type { ComposeTeamBenchCard } from '#src/__generated__/globalTypes.ts';

import { idFromObject } from './idFromObject.ts';

type AllowedConvertedTypes = ComposeTeamBenchCard['__typename'];

export const convertObjectId = (
  id: string,
  type: AllowedConvertedTypes
): string => {
  if (type === 'ComposeTeamBenchCard') {
    return `${type}:${idFromObject(id)}`;
  }
  return id;
};
